<template>
    <div class="flex justify-center items-center w-full h-screen">
        <div class="background container">

            <div class="left-side" :style="{ backgroundImage: image }"></div>

            <div class="right-side">

                <div class="forgot-password-header">
                    <router-link to="/">
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 352 512" class="forgot-password-close">
                            <path fill="currentColor"
                                  d="M242.72 256l100.07-100.07c12.28-12.28 12.28-32.19 0-44.48l-22.24-22.24c-12.28-12.28-32.19-12.28-44.48 0L176 189.28 75.93 89.21c-12.28-12.28-32.19-12.28-44.48 0L9.21 111.45c-12.28 12.28-12.28 32.19 0 44.48L109.28 256 9.21 356.07c-12.28 12.28-12.28 32.19 0 44.48l22.24 22.24c12.28 12.28 32.2 12.28 44.48 0L176 322.72l100.07 100.07c12.28 12.28 32.2 12.28 44.48 0l22.24-22.24c12.28-12.28 12.28-32.19 0-44.48L242.72 256z"></path>
                        </svg>
                    </router-link>
                </div>

                <div class="forgot-password-body">
                    <div class="logo">
                        <img src="/img/logo/ugt_logo.png" alt="UGT"
                             class="logotipo">
                    </div>
                    <h1 class="forgot-password-title">
                       Esqueceu sua senha?
                    </h1>
                    <h2 class="forgot-password-subtitle">
                        Digite seu CNPJ para continuar acessando o sistema.
                    </h2>
                    <validation-observer ref="forgot" v-slot="{handleSubmit}">
                        <form class="forgot-password-form"
                              @submit.prevent="handleSubmit(enviar)">

                            <validation-provider
                                name="CNPJ"
                                vid="cnpj"
                                rules="required|cnpj"
                                v-slot="{errors}"
                                tag="div"
                                class="form-group"
                            >
                                <div class="form-text">
                                    <label for="cpnj">CNPJ</label>
                                    <input
                                        type="text"
                                        id="cnpj"
                                        name="cnpj"
                                        v-mask="'##.###.###/####-##'"
                                        v-model="cnpjMask"
                                    >
                                </div>
                                <p class="errors">{{errors[0]}}</p>
                            </validation-provider>

                            <div class="forgot-password-buttons">
                                <router-link to="/sistema">Login</router-link>
                                <button class="btn btn-primary">Enviar</button>
                            </div>

                        </form>
                    </validation-observer>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { mask } from "vue-the-mask"
    import { sample } from "lodash"

    export default {
        name: "forgot-password",
        directives: { mask },
        data() {
            return {
                image: '',
                images: [
                    'linear-gradient(rgba(0, 0, 0, 0.6), rgba(0, 0, 0, 0.6)), url(../../../../img/bg/bg-login/bg-header-001.png)',
                    'linear-gradient(rgba(0, 0, 0, 0.6), rgba(0, 0, 0, 0.6)), url(../../../../img/bg/bg-login/bg-header-002.png)',
                    'linear-gradient(rgba(0, 0, 0, 0.6), rgba(0, 0, 0, 0.6)), url(../../../../img/bg/bg-login/bg-header-003.png)',
                    'linear-gradient(rgba(0, 0, 0, 0.6), rgba(0, 0, 0, 0.6)), url(../../../../img/bg/bg-login/bg-header-004.png)',
                    'linear-gradient(rgba(0, 0, 0, 0.6), rgba(0, 0, 0, 0.6)), url(../../../../img/bg/bg-login/bg-header-005.png)',
                    'linear-gradient(rgba(0, 0, 0, 0.6), rgba(0, 0, 0, 0.6)), url(../../../../img/bg/bg-login/bg-header-006.png)',
                    'linear-gradient(rgba(0, 0, 0, 0.6), rgba(0, 0, 0, 0.6)), url(../../../../img/bg/bg-login/bg-header-007.png)',
                    'linear-gradient(rgba(0, 0, 0, 0.6), rgba(0, 0, 0, 0.6)), url(../../../../img/bg/bg-login/bg-header-008.png)',
                    'linear-gradient(rgba(0, 0, 0, 0.6), rgba(0, 0, 0, 0.6)), url(../../../../img/bg/bg-login/bg-header-009.png)'
                ],
                cnpjMask: '',
                forgot: {
                    cnpj: '',
                }
            }
        },

        methods: {
            changeBg() {
                this.image = sample(this.images);
            },

            enviar() {
                this.forgot.cnpj = this.cnpjMask.replace(/[^\d]+/g,'')
                this.axios.post('/api/forgot-password/', this.forgot).then(response => {
                    this.$swal({
                        title: 'Sucesso',
                        text: 'Um e-mail foi enviado para alterar sua senha',
                        imageUrl: 'http://localhost:8000/img/icon/success.png',
                    }).then((result) => {
                        if (result.value) {
                            this.$router.push('/login');
                        }
                    })
                }).catch(errors => {
                    if (errors.response.status === 422) {
                        this.$refs.forgot.setErrors(errors.response.data.errors);
                    }
                });
            }
        },

        mounted() {
            this.changeBg();
        },
    }
</script>

<style lang="scss" scoped>
    @import "forgot-password";
</style>
